import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import App from './App';

const rootElement = document.getElementById('root');

// Check if we have SSR data from server
const ssrDataElement = document.getElementById('__INITIAL_PROFILE_DATA__');
let initialProfileData = null;

if (ssrDataElement) {
    try {
        initialProfileData = JSON.parse(ssrDataElement.textContent || '{}');
        console.log('✅ SSR data loaded:', initialProfileData);
        // Remove script tag after reading
        ssrDataElement.remove();
    } catch (e) {
        console.error('❌ Failed to parse SSR data:', e);
    }
}

// Check if we have SSR content to hydrate
const hasSSRContent = rootElement && rootElement.children.length > 0 && initialProfileData;

const appElement = (
    <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
        <App initialProfileData={initialProfileData} />
    </BrowserRouter>
);

// Use hydrate for SSR content, render for client-side
if (hasSSRContent) {
    console.log('🔄 Hydrating existing SSR content (React 17)...');
    ReactDOM.hydrate(appElement, rootElement);
} else {
    console.log('🎨 Rendering client-side...');
    ReactDOM.render(appElement, rootElement);
}

// Remove the initial BE spinner overlay once React is mounted
(window as any).__removeTolSpinner?.();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
